import { PureComponent, ReactNode } from 'react';
import ParseHtml from '../../helper/parser/htmlParser';

interface HtmlContentProps {
  htmlString: string;
}

interface HtmlContentState {
  domContent: ReactNode;
  htmlString: string;
}

class HtmlContent extends PureComponent<HtmlContentProps, HtmlContentState> {
  public static getDerivedStateFromProps(
    nextProps: HtmlContentProps,
    nextState: HtmlContentState
  ): Partial<HtmlContentState> | null {
    if (nextProps.htmlString !== nextState.htmlString) {
      return {
        domContent: ParseHtml(nextProps.htmlString),
        htmlString: nextProps.htmlString
      };
    }
    return null;
  }

  public state: HtmlContentState = {
    domContent: ParseHtml(this.props.htmlString),
    htmlString: this.props.htmlString
  };

  public render() {
    const { domContent } = this.state;
    return domContent;
  }
}

export { HtmlContent };
